import api from "./api";

/**
 * Termos de aceite — visão do supervisor.
 *
 * O supervisor NÃO aceita nem recusa nada: o aceite é sempre do cliente master. Aqui ele
 * só descobre quais clientes da carteira estão travados, para poder acionar a central.
 */

export interface PendenciaCarteira {
  idCliente: number;
  cliente: string;
  documento?: string | null;
  telefone?: string | null;
  termo: string;
  versao: string;
  /** RECUSADO | PRAZO_VENCIDO */
  motivo: string;
  prazoEfetivo: string;
  diasEmAtraso: number;
}

export interface PendenciasCarteira {
  perfil: string;
  clientesNaCarteira: number;
  /** quantos clientes distintos estão travados */
  clientes: number;
  mensagem?: string | null;
  itens: PendenciaCarteira[];
}

export default class TermosApi {
  static getPendenciasCarteira = async (): Promise<PendenciasCarteira> => {
    const response = await api.get("/portal/termos/carteira/pendencias");
    return response.data;
  };
}

export interface ClienteCarteira {
  id: number;
  nome: string;
  documento?: string | null;
  ativo: boolean;
  /** quantos termos esse cliente já recebeu — 0 = nunca recebeu */
  termos: number;
  bloqueado: boolean;
}

export interface TermoDoCliente {
  idTermNotice: number;
  idTermVersion: number;
  titulo: string;
  resumo?: string | null;
  termTypeCode: string;
  versao: string;
  status: string;
  publicadoEm: string;
  prazoAte: string;
  vencido: boolean;
  decididoEm?: string | null;
  decididoPor?: string | null;
  motivoRecusa?: string | null;
}

export class TermosCarteiraApi {
  /** Todos os clientes da carteira, inclusive os sem nenhum termo. */
  static getClientes = async (): Promise<ClienteCarteira[]> => {
    const r = await api.get("/portal/termos/carteira/clientes");
    return r.data;
  };

  static getTermosDoCliente = async (idCliente: number): Promise<TermoDoCliente[]> => {
    const r = await api.get(`/portal/termos/carteira/clientes/${idCliente}/termos`);
    return r.data;
  };

  static getDocumento = async (idCliente: number, idTermVersion: number) => {
    const r = await api.get(
      `/portal/termos/carteira/clientes/${idCliente}/documento?idTermVersion=${idTermVersion}&html=false`
    );
    return r.data as { html: string; hashRenderizado?: string | null; status: string };
  };
}
